export default {
    root: {
        transitionDuration: '{transition.duration}',
        focusRing: {
            width: '{focus.ring.width}',
            style: '{focus.ring.style}',
            color: '{focus.ring.color}',
            offset: '{focus.ring.offset}',
            shadow: '{focus.ring.shadow}'
        }
    },
    value: {
        background: '{primary.color}'
    },
    text: {
        color: '{text.muted.color}'
    },
    colorScheme: {
        light: {
            range: {
                background: '{surface.300}'
            }
        },
        dark: {
            range: {
                background: '{surface.600}'
            }
        }
    }
};
